<template>
  <div
    class="vx-card h-full flex justify-center items-center flex-col relative"
    style="min-height: 420px"
  >
    <div
      class="w-full absolute p-4 text-lg z-10 flex justify-between"
      style="top: 10px; right: 10px"
    >
      <div class="flex gap-1">
        <h5>فروش ماه جاری</h5>
        <span v-if="totalAmountToShow"
          >(کل:
          <span class="font-bold">{{
            Math.floor(totalAmountToShow).toLocaleString()
          }}</span>
          ریال)</span
        >
      </div>
    </div>
    <div
      class="flex w-full h-full gap-4 justify-center items-center flex-col mt-8 py-2"
      v-if="showChart"
    >
      <vue-apex-charts
        type="pie"
        height="200"
        :options="chartOptions"
        :series="series"
      />
      <div
        class="grid grid-cols-2 gap-x-3 gap-y-1 items-center px-2"
        style="direction: ltr"
      >
        <div
          class="gap-2 items-center cursor-default"
          v-for="item of chartColors"
          :key="item.hexColor"
        >
          <vx-tooltip :title="item.label" position="top" :color="item.hexColor">
            <div class="flex gap-2 items-center">
              <div
                class="w-6 h-6 rounded-full"
                :style="{ backgroundColor: item.hexColor }"
              ></div>
              <span class="text-sm">{{ item.label }}</span>
            </div>
            <template slot="content">
              <div
                style="direction: ltr"
                class="flex text-center w-full justify-center flex-col font-bold"
              >
                <div>
                  <span>{{ item.value.toLocaleString() }}</span>
                </div>
                <span
                  >{{
                    totalAmount
                      ? Number(((item.value / totalAmount) * 100).toFixed(2))
                      : 0
                  }}%</span
                >
              </div>
            </template>
          </vx-tooltip>
        </div>
      </div>
    </div>

    <Shimmer v-else class="w-full h-full"></Shimmer>
  </div>
</template>

<script>
import Shimmer from "@/components/Shimmer.vue";
import VueApexCharts from "vue-apexcharts";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      totalAmount: 0,
      totalAmountToShow: null,
      series: [],
      showChart: false,
      chartColors: [],
      chartOptions: {
        labels: [],
        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            return `
                <div class="pb-2 arrow_box flex flex-col" style="background-color: ${
                  w.globals.colors[seriesIndex]
                }">
                  <span class="px-2 pt-2 flex items-center justify-center" style="background-color: ${
                    w.globals.colors[seriesIndex]
                  }">
                    ${w.globals.seriesNames[seriesIndex]}
                  </span>
                  <hr class="my-1" style="display: block;
                    height: 1px;
                    border: 0;
                    border-top: 1px solid #dadada6b;
                    " />
                  <div class="flex flex-col gap-1 px-2">
                    <div class="flex gap-2 justify-center items-center">
                      <span style="direction: ltr !important" class='font-bold'>
                        ${series[seriesIndex].toLocaleString()}
                      </span>
                    </div>
                    <div class="flex gap-2 justify-center">
                        <span style="direction: ltr !important" class='font-bold'>
                            ${
                              this.totalAmount
                                ? Number(
                                    (
                                      (series[seriesIndex] / this.totalAmount) *
                                      100
                                    ).toFixed(2)
                                  )
                                : 0
                            }%
                        </span>
                    </div>
                  </div>
                </div>
              `;
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: { show: false },
        chart: {
          fontFamily: "IRANSans",
          type: "donut",
          dropShadow: {
            enabled: false,
            blur: 5,
            left: 1,
            top: 1,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: 0.5,
        },
        colors: [],
        fill: {},
      },
    };
  },
  computed: {
    ...mapGetters({
      segmentsColors: "theme/segmentsColors",
    }),
  },
  methods: {
    ...mapActions({
      fetchOrdersPerSegmentChartData: "reports/fetchOrdersPerSegmentChartData",
    }),
    getSegmentColor(segmentId) {
      const theSegment = this.segmentsColors.find(
        (segment) => segment.id == segmentId
      );
      if (theSegment) {
        return theSegment.color;
      }
      return "#bababa";
    },
  },
  mounted() {
    this.fetchOrdersPerSegmentChartData().then((response) => {
      let lables = [];
      let datasets = [];
      let noData = true;
      this.totalAmountToShow = response.totalAmountOfOrders;
      response.orderPerSegmentsDto.forEach((segment) => {
        lables.push(segment.segmentName);
        datasets.push(segment.amount);
        if (segment.amount > 0) noData = false;
        this.totalAmount = this.totalAmount + Number(segment.amount);
        const segmentColor = this.getSegmentColor(segment.segmentId);
        this.chartOptions.colors.push(segmentColor);
        this.chartColors.push({
          hexColor: segmentColor,
          label: segment.segmentName,
          value: segment.amount,
        });
      });
      if (noData) {
        this.chartOptions.labels = [];
        this.series = [1];
        this.chartOptions.colors = [];
        (this.chartOptions.tooltip = {
          custom: function () {
            return `
                    <div class="flex flex-col bg-white justify-center gap-2">
                        <span class="px-2 p-2 flex items-center justify-center" style="background-color: #7979798f">
                        هنوز فروشی ثبت نشده است
                        </span>
                    </div>
                  `;
          },
        }),
          this.chartOptions.colors.push("#c2c2c270");
      } else {
        this.chartOptions.labels = lables;
        this.series = datasets;
      }
      this.showChart = true;
    });
  },
  components: {
    Shimmer,
    VueApexCharts,
  },
};
</script>

<style scoped></style>
